import styled from "styled-components";

export const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    .fields{
        display: flex;
        flex-direction: column;
        width: 100%;
        .field{
            display: flex;
            flex-direction: column;
            width: 100%;
            margin-bottom: 15px;
            .born_date{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                .born_day,
                .born_month,
                .born_year{
                    width: calc((100% / 3) - 10px);
                    select{
                        width: 100%;
                    }
                    >label{
                        font-size: 15px;
                        line-height: 15px;
                        font-weight: 600;
                        margin-bottom: 3px;
                        font-weight: 600;
                    }
                }
            }
            >label{
                font-size: 14px;
                line-height: 14px;
                font-weight: 600;
                margin-bottom: 5px;
                font-weight: 600;
            }
            input,
            select{
                font-size: 15px;
                line-height: 15px;
                font-weight: 400;
                padding: 8px 8px;
                border: 1px solid #cccccc;
                border-radius: 6px;
                outline: 0;
                &.error{
                    border-color: red;
                }
            }
            &:last-child{
                margin-bottom: 0;
            }
        }
    }
    .aclaration_asterix{
        width: 100%;
        text-align: left;
        margin-top: 15px;
    }
    .actions{
        margin-top: 20px;;
    }

`

export const ButtonStyled = styled.div`
    background-color: #3DA5E0;
    color: #FFFFFF;
    font-weight: 800;
    text-transform: uppercase;
    padding: 16px 30px;
    border-radius: 6px;
    border: 1px solid #3DA5E0;
    cursor: pointer;
    &:hover{
        background-color: #FFFFFF;
        color: #3DA5E0;
    }
`